const initialState = {
  userData: {
    firebaseToken: null,
    mobileNumber: null,
    countryCode: null,
    userToken: null,
  },
};

const saveOtpReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SAVE_OTP":
      return {
        ...state,
        userData: payload,
      };
    default:
      return state;
  }
};
export default saveOtpReducer;
